"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package import
 */
const react_1 = __importStar(require("react"));
const crumble_1 = require("@oclock/crumble");
const react_toastify_1 = require("react-toastify");
/**
 * Local import
 */
const instances_1 = __importDefault(require("src/store/apis/instances"));
const DeleteDialog = ({ setOpen, instanceName, refetchInstances }) => {
    const [deleteInstance] = instances_1.default.useDeleteInstanceMutation();
    const [loadDelete, setLoadDelete] = (0, react_1.useState)(false);
    const handleCancel = () => setOpen(null);
    const handleSuccess = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoadDelete(true);
            yield deleteInstance(instanceName).unwrap();
            (0, react_toastify_1.toast)('L’instance a bien été supprimée.', { type: 'success' });
            refetchInstances();
        }
        catch (err) {
            (0, react_toastify_1.toast)('L’instance n’a pas pu être supprimée, veuillez réessayer.', { type: 'error' });
        }
        setLoadDelete(false);
        setOpen(null);
    });
    return (react_1.default.createElement(crumble_1.Dialog, { title: "Supprimer l'instance", desc: "Es-tu s\u00FBr de vouloir supprimer l'instance ? Cette action est irr\u00E9versible", cancelButtonProps: {
            type: 'button',
            onClick: handleCancel,
            disabled: loadDelete,
            label: "Annuler"
        }, successButtonProps: {
            type: 'button',
            onClick: handleSuccess,
            disabled: loadDelete,
            label: loadDelete ? 'Suppression en cours...' : 'Supprimer',
        } }));
};
exports.default = DeleteDialog;
